import { consola } from 'consola'
import { colors } from 'consola/utils'

export default defineNuxtPlugin(async (_nuxtApp) => {
  // 向控制台输出插件加载信息
  consola.wrapAll()
  consola.box({
    title: 'Maintenance plugin is loaded and ready to use!',
    message: 'Checking app maintenance mode...',
  })

  const showMaintenanced = useState<boolean>('showMaintenanced', () => false)

  const route = useRoute()
  const isMaintenanced = await isMaintenanceEnabled()
  // 如果未启用维护模式
  if (!isMaintenanced) {
    showMaintenanced.value = false
    return
  }
  const maintenanceConfig = await getMaintenanceModeConfig()

  // 处理 GETTING 绕过
  const bypassCookie = useCookie(BYPASS_COOKIE_NAME, {
    maxAge: 60 * 60 * 24 * 7 * 4, // 1 month
    sameSite: 'strict',
    secure: true,
  })
  let bypassCookieValue: string | null = bypassCookie.value ?? null

  // 处理设置绕过
  if (
    maintenanceConfig.bypassSecret
    && route.query.bypass === maintenanceConfig.bypassSecret
  ) {
  // 如果存在绕过查询参数，并且它与绕过密钥匹配，则设置绕过 cookie。
  // 这用于在后续请求中绕过维护模式。
    bypassCookie.value = maintenanceConfig.bypassSecret
    bypassCookieValue = maintenanceConfig.bypassSecret
  }

  // 处理维护检查
  if (!isUnderMaintenance(route.path, bypassCookieValue, maintenanceConfig)) {
    showMaintenanced.value = false
    return
  }

  showMaintenanced.value = true

  consola.box({

  })
})
